import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import dayjs from 'dayjs';

const useSnapshotFunctions = () => {
  const { generalApiCall } = useGeneralApiCall();
  const type_order = { drivingTheDay: 0, inCaseYouMissedIt: 1 };
  const typeRank = (type) => (type in type_order ? type_order[type] : 99);

  const listBriefings = async ({ filters, source, requestProperties: requestPropertiesProps = {} }) => {
    try {
      const briefings = await generalApiCall({
        method: 'post',
        pathname: `/api/briefings/list-briefings`,
        needsAuthentication: true,
        requestProperties: { filters, ...requestPropertiesProps },
        notShowErrorMessage: true,
        requestSource: source,
      });
      if (!!briefings) {
        let mostRecent,
          todayDate,
          results = [];

        if (!!briefings?.hits && briefings?.hits.length > 0) {
          results = [...briefings.hits].sort((a, b) => dayjs(b.date).valueOf() - dayjs(a.date).valueOf());
          const mostRecentDate = dayjs(results?.[0]?.date);
          mostRecent = results
            ?.filter((item) => dayjs(item?.date).isSame(mostRecentDate, 'day'))
            ?.sort((a, b) => typeRank(a.type) - typeRank(b.type));
          todayDate = dayjs().isSame(mostRecentDate, 'day');
        }
        return { results, mostRecent, todayDate };
      }
    } catch (error) {}
  };

  const getBriefingsByDate = async ({ filters, date, source }) => {
    try {
      const briefings = await generalApiCall({
        method: 'post',
        pathname: `/api/briefings/get-briefing`,
        needsAuthentication: true,
        requestProperties: { filters, date },
        notShowErrorMessage: true,
        requestSource: source,
      });
      if (!!briefings) {
        let mostRecent,
          results = [];
        if (!!briefings && briefings?.length > 0) {
          results = [...briefings].sort((a, b) => dayjs(b.date).valueOf() - dayjs(a.date).valueOf());
          const mostRecentDate = dayjs(results?.[0]?.date);
          mostRecent = results
            ?.filter((item) => dayjs(item?.date).isSame(mostRecentDate, 'day'))
            ?.sort((a, b) => typeRank(a.type) - typeRank(b.type));
        }
        return { results, mostRecent };
      }
    } catch (error) {}
  };

  const addFeedback = async ({ snapshotItemId, url }) => {
    const pathname = '/api/briefings/briefing-content-feedback';
    const method = 'post';
    let requestProperties = { snapshotItemId, url, feedbackType: 'NotImportant' };
    const results = await generalApiCall({
      pathname,
      method,
      requestProperties,
      needsAuthentication: true,
      returnCompleteRequest: true,
      returnError: true,
    });
    return results;
  };

  const removeFeedback = async ({ snapshotItemId, url }) => {
    try {
      const requestProperties = { snapshotItemId, url };
      const results = await generalApiCall({
        pathname: '/api/briefings/remove-briefing-content-feedback',
        method: 'post',
        requestProperties,
        needsAuthentication: true,
        returnCompleteRequest: true,
        returnError: true,
      });

      return results;
    } catch (error) {}
  };

  const updateIncludedForBriefings = async ({ keywordListId, includeInBriefings }) => {
    try {
      const pathname = '/api/briefings/set-keyword-list-inclusion';
      const method = 'post';
      let requestProperties = { keywordListId, includeInBriefings };
      const results = await generalApiCall({
        pathname,
        method,
        requestProperties,
        needsAuthentication: true,
        returnError: true,
      });
      return results;
    } catch (error) {}
  };

  return { listBriefings, getBriefingsByDate, addFeedback, updateIncludedForBriefings, typeRank, removeFeedback };
};

export default useSnapshotFunctions;
